module.exports = __webpack_public_path__ + "img/c91d1cc1b7af4d17c41c873c694a21ce.c91d1cc1.png";